/* eslint-disable no-nested-ternary */
import React, { FC } from 'react';
import { useRouter } from 'next/router';
import { styled } from 'linaria/react';
import isArray from 'lodash/isArray';
import { useTheme } from '@shared/lib';
interface Props {
  contextMenus: React.ReactNode[] | React.ReactNode;
  currentPath: React.ReactNode;
}
export const SeparateLine: FC = () => {
  const router = useRouter();
  const theme = useTheme();
  const isPayQRPage = router.asPath.includes('pay-qr');
  const isPubgGiveawayPage = router.asPath.includes('rozygrysh-prizov-pubg-mobile');
  const isVesenniiRozygryshPage = router.asPath.includes('vesennii-rozygrysh-prizov-2026');
  const isGenshinPubgResultsPage = router.asPath.includes('rozygrysh-prizov-genshin-pubg-itogi');
  const isDvoinoiShansNaPobeduPage = router.asPath.includes('dvoinoi-shans-na-pobedu');
  const isOsenniiRozygryshPrizov2026Page = router.asPath.includes('osennii-rozygrysh-prizov-2026');
  return <WrapperItem>
      <Separate>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_4903_11023)">
            <path d="M9 5.01246C9 4.11226 10.0766 3.66144 10.7062 4.29798L13.8016 7.4273C15.9339 9.58289 17 10.6607 17 12C17 13.3393 15.9339 14.4171 13.8016 16.5727L10.7062 19.702C10.0766 20.3386 9 19.8877 9 18.9875C9 18.7196 9.1053 18.4625 9.29274 18.2731L12.3882 15.1437C13.4942 14.0255 14.1786 13.3276 14.6112 12.7544C15.0016 12.2371 15.0012 12.0565 15.001 12.0028L15.001 12L15.001 11.9973C15.0012 11.9435 15.0016 11.7629 14.6112 11.2456C14.1786 10.6724 13.4942 9.97446 12.3882 8.85627L9.29274 5.72695C9.1053 5.53745 9 5.28044 9 5.01246Z" fill={isPayQRPage ? '#969FA8' : isPubgGiveawayPage ? '#BBC1C7' : isVesenniiRozygryshPage ? '#EBF1FD' : isGenshinPubgResultsPage ? '#FAFAFA' : isDvoinoiShansNaPobeduPage ? '#EBF1FD' : isOsenniiRozygryshPrizov2026Page ? '#adb0cc' : theme.colors.icon.tertiary} />
          </g>
          <defs>
            <clipPath id="clip0_4903_11023">
              <rect width="24" height="24" fill={theme.colors.icon.white} />
            </clipPath>
          </defs>
        </svg>
      </Separate>
    </WrapperItem>;
};
const ContextMenu: FC<{
  menuList: React.ReactNode[];
}> = ({
  menuList
}) => {
  const menuCount = menuList.length;
  return <>
      {menuList.map((menuText, index) => {
      const isLastElement = index === menuCount - 1;
      if (isLastElement) {
        return <Item key={index}>{menuText}</Item>;
      }
      return <Wrapper key={index}>
            <WrapperItem>{menuText}</WrapperItem>
            <SeparateLine />
          </Wrapper>;
    })}
    </>;
};
export const BreadcrumbsUI: FC<Props> = ({
  contextMenus,
  currentPath
}) => {
  const menuList = isArray(contextMenus) ? contextMenus : [contextMenus];
  const renderCurrentPath = () => <>
      {contextMenus && <SeparateLine />}
      <WrapperItem>{currentPath}</WrapperItem>
    </>;
  return <Wrapper>
      {contextMenus && <ContextMenu menuList={menuList} />}
      {currentPath && renderCurrentPath()}
    </Wrapper>;
};
const Wrapper = /*#__PURE__*/styled('ol')({
  name: "Wrapper",
  class: "w1km12i8",
  propsAsIs: false
});
const WrapperItem = /*#__PURE__*/styled('li')({
  name: "WrapperItem",
  class: "w19l9vyo",
  propsAsIs: false
});
const Item = /*#__PURE__*/styled('div')({
  name: "Item",
  class: "ih5j9ll",
  propsAsIs: false
});
const Separate = /*#__PURE__*/styled('div')({
  name: "Separate",
  class: "szila4c",
  propsAsIs: false
});

require("./BreadcrumbsUI.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./BreadcrumbsUI.tsx");